import React from 'react';
import ProfileAvatar from './ProfileAvatar';

/**
 * ChatRequestModal - Consent-First Chat Request UI
 * 
 * Displays when someone requests to chat with you in the Lounge.
 * 
 * Design philosophy:
 * - Clear, respectful ask
 * - Easy to decline
 * - Puts recipient in control
 */
export default function ChatRequestModal({ request, onAccept, onDecline, isResponding }) {
  if (!request) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-slate-900 text-slate-50 p-6 rounded-2xl max-w-sm w-[90%] shadow-2xl border border-slate-700">
        {/* Avatar */}
        <div className="flex justify-center mb-4">
          <ProfileAvatar
            profile={{ avatar_url: request.from_avatar_url }}
            size={64}
            alt={request.from_display_name}
          />
        </div>

        {/* Message */}
        <div className="text-center mb-6">
          <p className="text-sm text-emerald-400 mb-2">
            Someone wants a moment with you 💜
          </p>
          <p className="font-semibold text-lg mb-2">
            {request.from_display_name || 'Another member'} noticed you in the Lounge.
          </p>
          <p className="text-xs text-slate-400">
            You're always in control — only say yes if it feels good to you.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            className="flex-1 px-4 py-2.5 rounded-full border border-slate-600 text-slate-300 hover:bg-slate-800 hover:border-slate-500 transition disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onDecline}
            disabled={isResponding}
          >
            Not right now
          </button>
          <button
            className="flex-1 px-4 py-2.5 rounded-full bg-emerald-500 text-slate-900 font-semibold hover:bg-emerald-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onAccept}
            disabled={isResponding}
          >
            Yes, open chat
          </button>
        </div>

        {/* Expiry indicator */}
        <p className="text-center text-xs text-slate-500 mt-3">
          This request expires in ~90 seconds
        </p>
      </div>
    </div>
  );
}
